function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get; } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }

function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }

function _construct(Parent, args, Class) { if (_isNativeReflectConstruct()) { _construct = Reflect.construct; } else { _construct = function _construct(Parent, args, Class) { var a = [null]; a.push.apply(a, args); var Constructor = Function.bind.apply(Parent, a); var instance = new Constructor(); if (Class) _setPrototypeOf(instance, Class.prototype); return instance; }; } return _construct.apply(null, arguments); }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _isNativeFunction(fn) { return Function.toString.call(fn).indexOf("[native code]") !== -1; }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var Scope = /* @__PURE__ */function (Scope2) {
  return Scope2[Scope2.TYPE = 3] = "TYPE", Scope2[Scope2.LEVEL = 12] = "LEVEL", Scope2[Scope2.ATTRIBUTE = 13] = "ATTRIBUTE", Scope2[Scope2.BLOT = 14] = "BLOT", Scope2[Scope2.INLINE = 7] = "INLINE", Scope2[Scope2.BLOCK = 11] = "BLOCK", Scope2[Scope2.BLOCK_BLOT = 10] = "BLOCK_BLOT", Scope2[Scope2.INLINE_BLOT = 6] = "INLINE_BLOT", Scope2[Scope2.BLOCK_ATTRIBUTE = 9] = "BLOCK_ATTRIBUTE", Scope2[Scope2.INLINE_ATTRIBUTE = 5] = "INLINE_ATTRIBUTE", Scope2[Scope2.ANY = 15] = "ANY", Scope2;
}(Scope || {});

var Attributor = /*#__PURE__*/function () {
  function Attributor(attrName, keyName) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    _classCallCheck(this, Attributor);

    this.attrName = attrName, this.keyName = keyName;
    var attributeBit = Scope.TYPE & Scope.ATTRIBUTE;
    this.scope = options.scope != null ? // Ignore type bits, force attribute bit
    options.scope & Scope.LEVEL | attributeBit : Scope.ATTRIBUTE, options.whitelist != null && (this.whitelist = options.whitelist);
  }

  _createClass(Attributor, [{
    key: "add",
    value: function add(node, value) {
      return this.canAdd(node, value) ? (node.setAttribute(this.keyName, value), !0) : !1;
    }
  }, {
    key: "canAdd",
    value: function canAdd(_node, value) {
      return this.whitelist == null ? !0 : typeof value == "string" ? this.whitelist.indexOf(value.replace(/["']/g, "")) > -1 : this.whitelist.indexOf(value) > -1;
    }
  }, {
    key: "remove",
    value: function remove(node) {
      node.removeAttribute(this.keyName);
    }
  }, {
    key: "value",
    value: function value(node) {
      var value = node.getAttribute(this.keyName);
      return this.canAdd(node, value) && value ? value : "";
    }
  }], [{
    key: "keys",
    value: function keys(node) {
      return Array.from(node.attributes).map(function (item) {
        return item.name;
      });
    }
  }]);

  return Attributor;
}();

var ParchmentError = /*#__PURE__*/function (_Error) {
  _inherits(ParchmentError, _Error);

  var _super = _createSuper(ParchmentError);

  function ParchmentError(message) {
    var _this;

    _classCallCheck(this, ParchmentError);

    message = "[Parchment] " + message, _this = _super.call(this, message), _this.message = message, _this.name = _this.constructor.name;
    return _this;
  }

  return _createClass(ParchmentError);
}( /*#__PURE__*/_wrapNativeSuper(Error));

var _Registry = /*#__PURE__*/function () {
  function _Registry() {
    _classCallCheck(this, _Registry);

    this.attributes = {}, this.classes = {}, this.tags = {}, this.types = {};
  }

  _createClass(_Registry, [{
    key: "create",
    value: function create(scroll, input, value) {
      var match2 = this.query(input);
      if (match2 == null) throw new ParchmentError("Unable to create ".concat(input, " blot"));
      var blotClass = match2,
          node = // @ts-expect-error Fix me later
      input instanceof Node || input.nodeType === Node.TEXT_NODE ? input : blotClass.create(value),
          blot = new blotClass(scroll, node, value);
      return _Registry.blots.set(blot.domNode, blot), blot;
    }
  }, {
    key: "find",
    value: function find(node) {
      var bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      return _Registry.find(node, bubble);
    }
  }, {
    key: "query",
    value: function query(_query) {
      var _this2 = this;

      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Scope.ANY;
      var match2;
      return typeof _query == "string" ? match2 = this.types[_query] || this.attributes[_query] : _query instanceof Text || _query.nodeType === Node.TEXT_NODE ? match2 = this.types.text : typeof _query == "number" ? _query & Scope.LEVEL & Scope.BLOCK ? match2 = this.types.block : _query & Scope.LEVEL & Scope.INLINE && (match2 = this.types.inline) : _query instanceof Element && ((_query.getAttribute("class") || "").split(/\s+/).some(function (name) {
        return match2 = _this2.classes[name], !!match2;
      }), match2 = match2 || this.tags[_query.tagName]), match2 == null ? null : "scope" in match2 && scope & Scope.LEVEL & match2.scope && scope & Scope.TYPE & match2.scope ? match2 : null;
    }
  }, {
    key: "register",
    value: function register() {
      var _this3 = this;

      for (var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++) {
        definitions[_key] = arguments[_key];
      }

      return definitions.map(function (definition) {
        var isBlot = ("blotName" in definition),
            isAttr = ("attrName" in definition);
        if (!isBlot && !isAttr) throw new ParchmentError("Invalid definition");
        if (isBlot && definition.blotName === "abstract") throw new ParchmentError("Cannot register abstract class");
        var key = isBlot ? definition.blotName : isAttr ? definition.attrName : void 0;
        return _this3.types[key] = definition, isAttr ? typeof definition.keyName == "string" && (_this3.attributes[definition.keyName] = definition) : isBlot && (definition.className && (_this3.classes[definition.className] = definition), definition.tagName && (Array.isArray(definition.tagName) ? definition.tagName = definition.tagName.map(function (tagName) {
          return tagName.toUpperCase();
        }) : definition.tagName = definition.tagName.toUpperCase(), (Array.isArray(definition.tagName) ? definition.tagName : [definition.tagName]).forEach(function (tag) {
          (_this3.tags[tag] == null || definition.className == null) && (_this3.tags[tag] = definition);
        }))), definition;
      });
    }
  }], [{
    key: "find",
    value: function find(node) {
      var bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      if (node == null) return null;
      if (this.blots.has(node)) return this.blots.get(node) || null;

      if (bubble) {
        var parentNode = null;

        try {
          parentNode = node.parentNode;
        } catch (_unused) {
          return null;
        }

        return this.find(parentNode, bubble);
      }

      return null;
    }
  }]);

  return _Registry;
}();

_Registry.blots = /* @__PURE__ */new WeakMap();
var Registry = _Registry;

function match(node, prefix) {
  return (node.getAttribute("class") || "").split(/\s+/).filter(function (name) {
    return name.indexOf("".concat(prefix, "-")) === 0;
  });
}

var ClassAttributor = /*#__PURE__*/function (_Attributor) {
  _inherits(ClassAttributor, _Attributor);

  var _super2 = _createSuper(ClassAttributor);

  function ClassAttributor() {
    _classCallCheck(this, ClassAttributor);

    return _super2.apply(this, arguments);
  }

  _createClass(ClassAttributor, [{
    key: "add",
    value: function add(node, value) {
      return this.canAdd(node, value) ? (this.remove(node), node.classList.add("".concat(this.keyName, "-").concat(value)), !0) : !1;
    }
  }, {
    key: "remove",
    value: function remove(node) {
      match(node, this.keyName).forEach(function (name) {
        node.classList.remove(name);
      }), node.classList.length === 0 && node.removeAttribute("class");
    }
  }, {
    key: "value",
    value: function value(node) {
      var value = (match(node, this.keyName)[0] || "").slice(this.keyName.length + 1);
      return this.canAdd(node, value) ? value : "";
    }
  }], [{
    key: "keys",
    value: function keys(node) {
      return (node.getAttribute("class") || "").split(/\s+/).map(function (name) {
        return name.split("-").slice(0, -1).join("-");
      });
    }
  }]);

  return ClassAttributor;
}(Attributor);

var ClassAttributor$1 = ClassAttributor;

function camelize(name) {
  var parts = name.split("-"),
      rest = parts.slice(1).map(function (part) {
    return part[0].toUpperCase() + part.slice(1);
  }).join("");
  return parts[0] + rest;
}

var StyleAttributor = /*#__PURE__*/function (_Attributor2) {
  _inherits(StyleAttributor, _Attributor2);

  var _super3 = _createSuper(StyleAttributor);

  function StyleAttributor() {
    _classCallCheck(this, StyleAttributor);

    return _super3.apply(this, arguments);
  }

  _createClass(StyleAttributor, [{
    key: "add",
    value: function add(node, value) {
      return this.canAdd(node, value) ? (node.style[camelize(this.keyName)] = value, !0) : !1;
    }
  }, {
    key: "remove",
    value: function remove(node) {
      node.style[camelize(this.keyName)] = "", node.getAttribute("style") || node.removeAttribute("style");
    }
  }, {
    key: "value",
    value: function value(node) {
      var value = node.style[camelize(this.keyName)];
      return this.canAdd(node, value) ? value : "";
    }
  }], [{
    key: "keys",
    value: function keys(node) {
      return (node.getAttribute("style") || "").split(";").map(function (value) {
        return value.split(":")[0].trim();
      });
    }
  }]);

  return StyleAttributor;
}(Attributor);

var StyleAttributor$1 = StyleAttributor;

var AttributorStore = /*#__PURE__*/function () {
  function AttributorStore(domNode) {
    _classCallCheck(this, AttributorStore);

    this.attributes = {}, this.domNode = domNode, this.build();
  }

  _createClass(AttributorStore, [{
    key: "attribute",
    value: function attribute(_attribute, value) {
      value ? _attribute.add(this.domNode, value) && (_attribute.value(this.domNode) != null ? this.attributes[_attribute.attrName] = _attribute : delete this.attributes[_attribute.attrName]) : (_attribute.remove(this.domNode), delete this.attributes[_attribute.attrName]);
    }
  }, {
    key: "build",
    value: function build() {
      var _this4 = this;

      this.attributes = {};
      var blot = Registry.find(this.domNode);
      if (blot == null) return;
      var attributes = Attributor.keys(this.domNode),
          classes = ClassAttributor$1.keys(this.domNode),
          styles = StyleAttributor$1.keys(this.domNode);
      attributes.concat(classes).concat(styles).forEach(function (name) {
        var attr = blot.scroll.query(name, Scope.ATTRIBUTE);
        attr instanceof Attributor && (_this4.attributes[attr.attrName] = attr);
      });
    }
  }, {
    key: "copy",
    value: function copy(target) {
      var _this5 = this;

      Object.keys(this.attributes).forEach(function (key) {
        var value = _this5.attributes[key].value(_this5.domNode);

        target.format(key, value);
      });
    }
  }, {
    key: "move",
    value: function move(target) {
      var _this6 = this;

      this.copy(target), Object.keys(this.attributes).forEach(function (key) {
        _this6.attributes[key].remove(_this6.domNode);
      }), this.attributes = {};
    }
  }, {
    key: "values",
    value: function values() {
      var _this7 = this;

      return Object.keys(this.attributes).reduce(function (attributes, name) {
        return attributes[name] = _this7.attributes[name].value(_this7.domNode), attributes;
      }, {});
    }
  }]);

  return AttributorStore;
}();

var AttributorStore$1 = AttributorStore,
    _ShadowBlot = /*#__PURE__*/function () {
  function _ShadowBlot(scroll, domNode) {
    _classCallCheck(this, _ShadowBlot);

    this.scroll = scroll, this.domNode = domNode, Registry.blots.set(domNode, this), this.prev = null, this.next = null;
  }

  _createClass(_ShadowBlot, [{
    key: "statics",
    get: // Hack for accessing inherited static methods
    function get() {
      return this.constructor;
    }
  }, {
    key: "attach",
    value: function attach() {}
  }, {
    key: "clone",
    value: function clone() {
      var domNode = this.domNode.cloneNode(!1);
      return this.scroll.create(domNode);
    }
  }, {
    key: "detach",
    value: function detach() {
      this.parent != null && this.parent.removeChild(this), Registry.blots["delete"](this.domNode);
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      this.isolate(index, length).remove();
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      var blot = this.isolate(index, length);
      if (this.scroll.query(name, Scope.BLOT) != null && value) blot.wrap(name, value);else if (this.scroll.query(name, Scope.ATTRIBUTE) != null) {
        var parent = this.scroll.create(this.statics.scope);
        blot.wrap(parent), parent.format(name, value);
      }
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      var blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def),
          ref = this.split(index);
      this.parent.insertBefore(blot, ref || void 0);
    }
  }, {
    key: "isolate",
    value: function isolate(index, length) {
      var target = this.split(index);
      if (target == null) throw new Error("Attempt to isolate at end");
      return target.split(length), target;
    }
  }, {
    key: "length",
    value: function length() {
      return 1;
    }
  }, {
    key: "offset",
    value: function offset() {
      var root = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.parent;
      return this.parent == null || this === root ? 0 : this.parent.children.offset(this) + this.parent.offset(root);
    }
  }, {
    key: "optimize",
    value: function optimize(_context) {
      this.statics.requiredContainer && !(this.parent instanceof this.statics.requiredContainer) && this.wrap(this.statics.requiredContainer.blotName);
    }
  }, {
    key: "remove",
    value: function remove() {
      this.domNode.parentNode != null && this.domNode.parentNode.removeChild(this.domNode), this.detach();
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(name, value) {
      var replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
      return this.parent != null && (this.parent.insertBefore(replacement, this.next || void 0), this.remove()), replacement;
    }
  }, {
    key: "split",
    value: function split(index, _force) {
      return index === 0 ? this : this.next;
    }
  }, {
    key: "update",
    value: function update(_mutations, _context) {}
  }, {
    key: "wrap",
    value: function wrap(name, value) {
      var wrapper = typeof name == "string" ? this.scroll.create(name, value) : name;
      if (this.parent != null && this.parent.insertBefore(wrapper, this.next || void 0), typeof wrapper.appendChild != "function") throw new ParchmentError("Cannot wrap ".concat(name));
      return wrapper.appendChild(this), wrapper;
    }
  }], [{
    key: "create",
    value: function create(rawValue) {
      if (this.tagName == null) throw new ParchmentError("Blot definition missing tagName");
      var node, value;
      return Array.isArray(this.tagName) ? (typeof rawValue == "string" ? (value = rawValue.toUpperCase(), parseInt(value, 10).toString() === value && (value = parseInt(value, 10))) : typeof rawValue == "number" && (value = rawValue), typeof value == "number" ? node = document.createElement(this.tagName[value - 1]) : value && this.tagName.indexOf(value) > -1 ? node = document.createElement(value) : node = document.createElement(this.tagName[0])) : node = document.createElement(this.tagName), this.className && node.classList.add(this.className), node;
    }
  }]);

  return _ShadowBlot;
}();

_ShadowBlot.blotName = "abstract";
var ShadowBlot = _ShadowBlot;

var _LeafBlot = /*#__PURE__*/function (_ShadowBlot2) {
  _inherits(_LeafBlot, _ShadowBlot2);

  var _super4 = _createSuper(_LeafBlot);

  function _LeafBlot() {
    _classCallCheck(this, _LeafBlot);

    return _super4.apply(this, arguments);
  }

  _createClass(_LeafBlot, [{
    key: "index",
    value:
    /**
     * Given location represented by node and offset from DOM Selection Range,
     * return index to that location.
     */
    function index(node, offset) {
      return this.domNode === node || this.domNode.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY ? Math.min(offset, 1) : -1;
    }
    /**
     * Given index to location within blot, return node and offset representing
     * that location, consumable by DOM Selection Range
     */

  }, {
    key: "position",
    value: function position(index, _inclusive) {
      var offset = Array.from(this.parent.domNode.childNodes).indexOf(this.domNode);
      return index > 0 && (offset += 1), [this.parent.domNode, offset];
    }
    /**
     * Return value represented by this blot
     * Should not change without interaction from API or
     * user change detectable by update()
     */

  }, {
    key: "value",
    value: function value() {
      return _defineProperty({}, this.statics.blotName, this.statics.value(this.domNode) || !0);
    }
  }], [{
    key: "value",
    value:
    /**
     * Returns the value represented by domNode if it is this Blot's type
     * No checking that domNode can represent this Blot type is required so
     * applications needing it should check externally before calling.
     */
    function value(_domNode) {
      return !0;
    }
  }]);

  return _LeafBlot;
}(ShadowBlot);

_LeafBlot.scope = Scope.INLINE_BLOT;
var LeafBlot = _LeafBlot;
var LeafBlot$1 = LeafBlot;

var LinkedList = /*#__PURE__*/function () {
  function LinkedList() {
    _classCallCheck(this, LinkedList);

    this.head = null, this.tail = null, this.length = 0;
  }

  _createClass(LinkedList, [{
    key: "append",
    value: function append() {
      for (var _len2 = arguments.length, nodes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        nodes[_key2] = arguments[_key2];
      }

      if (this.insertBefore(nodes[0], null), nodes.length > 1) {
        var rest = nodes.slice(1);
        this.append.apply(this, _toConsumableArray(rest));
      }
    }
  }, {
    key: "at",
    value: function at(index) {
      var next = this.iterator();
      var cur = next();

      for (; cur && index > 0;) {
        index -= 1, cur = next();
      }

      return cur;
    }
  }, {
    key: "contains",
    value: function contains(node) {
      var next = this.iterator();
      var cur = next();

      for (; cur;) {
        if (cur === node) return !0;
        cur = next();
      }

      return !1;
    }
  }, {
    key: "indexOf",
    value: function indexOf(node) {
      var next = this.iterator();
      var cur = next(),
          index = 0;

      for (; cur;) {
        if (cur === node) return index;
        index += 1, cur = next();
      }

      return -1;
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(node, refNode) {
      node != null && (this.remove(node), node.next = refNode, refNode != null ? (node.prev = refNode.prev, refNode.prev != null && (refNode.prev.next = node), refNode.prev = node, refNode === this.head && (this.head = node)) : this.tail != null ? (this.tail.next = node, node.prev = this.tail, this.tail = node) : (node.prev = null, this.head = this.tail = node), this.length += 1);
    }
  }, {
    key: "offset",
    value: function offset(target) {
      var index = 0,
          cur = this.head;

      for (; cur != null;) {
        if (cur === target) return index;
        index += cur.length(), cur = cur.next;
      }

      return -1;
    }
  }, {
    key: "remove",
    value: function remove(node) {
      this.contains(node) && (node.prev != null && (node.prev.next = node.next), node.next != null && (node.next.prev = node.prev), node === this.head && (this.head = node.next), node === this.tail && (this.tail = node.prev), this.length -= 1);
    }
  }, {
    key: "iterator",
    value: function iterator() {
      var curNode = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.head;
      return function () {
        var ret = curNode;
        return curNode != null && (curNode = curNode.next), ret;
      };
    }
  }, {
    key: "find",
    value: function find(index) {
      var inclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var next = this.iterator();
      var cur = next();

      for (; cur;) {
        var length = cur.length();
        if (index < length || inclusive && index === length && (cur.next == null || cur.next.length() !== 0)) return [cur, index];
        index -= length, cur = next();
      }

      return [null, 0];
    }
  }, {
    key: "forEach",
    value: function forEach(callback) {
      var next = this.iterator();
      var cur = next();

      for (; cur;) {
        callback(cur), cur = next();
      }
    }
  }, {
    key: "forEachAt",
    value: function forEachAt(index, length, callback) {
      if (length <= 0) return;

      var _this$find = this.find(index),
          _this$find2 = _slicedToArray(_this$find, 2),
          startNode = _this$find2[0],
          offset = _this$find2[1];

      var curIndex = index - offset;
      var next = this.iterator(startNode);
      var cur = next();

      for (; cur && curIndex < index + length;) {
        var curLength = cur.length();
        index > curIndex ? callback(cur, index - curIndex, Math.min(length, curIndex + curLength - index)) : callback(cur, 0, Math.min(curLength, index + length - curIndex)), curIndex += curLength, cur = next();
      }
    }
  }, {
    key: "map",
    value: function map(callback) {
      return this.reduce(function (memo, cur) {
        return memo.push(callback(cur)), memo;
      }, []);
    }
  }, {
    key: "reduce",
    value: function reduce(callback, memo) {
      var next = this.iterator();
      var cur = next();

      for (; cur;) {
        memo = callback(memo, cur), cur = next();
      }

      return memo;
    }
  }]);

  return LinkedList;
}();

function makeAttachedBlot(node, scroll) {
  var found = scroll.find(node);
  if (found) return found;

  try {
    return scroll.create(node);
  } catch (_unused2) {
    var blot = scroll.create(Scope.INLINE);
    return Array.from(node.childNodes).forEach(function (child) {
      blot.domNode.appendChild(child);
    }), node.parentNode && node.parentNode.replaceChild(blot.domNode, node), blot.attach(), blot;
  }
}

var _ParentBlot = /*#__PURE__*/function (_ShadowBlot3) {
  _inherits(_ParentBlot, _ShadowBlot3);

  var _super5 = _createSuper(_ParentBlot);

  function _ParentBlot(scroll, domNode) {
    var _this8;

    _classCallCheck(this, _ParentBlot);

    _this8 = _super5.call(this, scroll, domNode), _this8.uiNode = null, _this8.build();
    return _this8;
  }

  _createClass(_ParentBlot, [{
    key: "appendChild",
    value: function appendChild(other) {
      this.insertBefore(other);
    }
  }, {
    key: "attach",
    value: function attach() {
      _get(_getPrototypeOf(_ParentBlot.prototype), "attach", this).call(this), this.children.forEach(function (child) {
        child.attach();
      });
    }
  }, {
    key: "attachUI",
    value: function attachUI(node) {
      this.uiNode != null && this.uiNode.remove(), this.uiNode = node, _ParentBlot.uiClass && this.uiNode.classList.add(_ParentBlot.uiClass), this.uiNode.setAttribute("contenteditable", "false"), this.domNode.insertBefore(this.uiNode, this.domNode.firstChild);
    }
    /**
     * Called during construction, should fill its own children LinkedList.
     */

  }, {
    key: "build",
    value: function build() {
      var _this9 = this;

      this.children = new LinkedList(), Array.from(this.domNode.childNodes).filter(function (node) {
        return node !== _this9.uiNode;
      }).reverse().forEach(function (node) {
        try {
          var child = makeAttachedBlot(node, _this9.scroll);

          _this9.insertBefore(child, _this9.children.head || void 0);
        } catch (err) {
          if (err instanceof ParchmentError) return;
          throw err;
        }
      });
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      if (index === 0 && length === this.length()) return this.remove();
      this.children.forEachAt(index, length, function (child, offset, childLength) {
        child.deleteAt(offset, childLength);
      });
    }
  }, {
    key: "descendant",
    value: function descendant(criteria) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

      var _this$children$find = this.children.find(index),
          _this$children$find2 = _slicedToArray(_this$children$find, 2),
          child = _this$children$find2[0],
          offset = _this$children$find2[1];

      return criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria ? [child, offset] : child instanceof _ParentBlot ? child.descendant(criteria, offset) : [null, -1];
    }
  }, {
    key: "descendants",
    value: function descendants(criteria) {
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var length = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : Number.MAX_VALUE;
      var descendants = [],
          lengthLeft = length;
      return this.children.forEachAt(index, length, function (child, childIndex, childLength) {
        (criteria.blotName == null && criteria(child) || criteria.blotName != null && child instanceof criteria) && descendants.push(child), child instanceof _ParentBlot && (descendants = descendants.concat(child.descendants(criteria, childIndex, lengthLeft))), lengthLeft -= childLength;
      }), descendants;
    }
  }, {
    key: "detach",
    value: function detach() {
      this.children.forEach(function (child) {
        child.detach();
      }), _get(_getPrototypeOf(_ParentBlot.prototype), "detach", this).call(this);
    }
  }, {
    key: "enforceAllowedChildren",
    value: function enforceAllowedChildren() {
      var _this10 = this;

      var done = !1;
      this.children.forEach(function (child) {
        done || _this10.statics.allowedChildren.some(function (def) {
          return child instanceof def;
        }) || (child.statics.scope === Scope.BLOCK_BLOT ? (child.next != null && _this10.splitAfter(child), child.prev != null && _this10.splitAfter(child.prev), child.parent.unwrap(), done = !0) : child instanceof _ParentBlot ? child.unwrap() : child.remove());
      });
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      this.children.forEachAt(index, length, function (child, offset, childLength) {
        child.formatAt(offset, childLength, name, value);
      });
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      var _this$children$find3 = this.children.find(index),
          _this$children$find4 = _slicedToArray(_this$children$find3, 2),
          child = _this$children$find4[0],
          offset = _this$children$find4[1];

      if (child) child.insertAt(offset, value, def);else {
        var blot = def == null ? this.scroll.create("text", value) : this.scroll.create(value, def);
        this.appendChild(blot);
      }
    }
  }, {
    key: "insertBefore",
    value: function insertBefore(childBlot, refBlot) {
      childBlot.parent != null && childBlot.parent.children.remove(childBlot);
      var refDomNode = null;
      this.children.insertBefore(childBlot, refBlot || null), childBlot.parent = this, refBlot != null && (refDomNode = refBlot.domNode), (this.domNode.parentNode !== childBlot.domNode || this.domNode.nextSibling !== refDomNode) && this.domNode.insertBefore(childBlot.domNode, refDomNode), childBlot.attach();
    }
  }, {
    key: "length",
    value: function length() {
      return this.children.reduce(function (memo, child) {
        return memo + child.length();
      }, 0);
    }
  }, {
    key: "moveChildren",
    value: function moveChildren(targetParent, refNode) {
      this.children.forEach(function (child) {
        targetParent.insertBefore(child, refNode);
      });
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      if (_get(_getPrototypeOf(_ParentBlot.prototype), "optimize", this).call(this, context), this.enforceAllowedChildren(), this.uiNode != null && this.uiNode !== this.domNode.firstChild && this.domNode.insertBefore(this.uiNode, this.domNode.firstChild), this.children.length === 0) if (this.statics.defaultChild != null) {
        var child = this.scroll.create(this.statics.defaultChild.blotName);
        this.appendChild(child);
      } else this.remove();
    }
  }, {
    key: "path",
    value: function path(index) {
      var inclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      var _this$children$find5 = this.children.find(index, inclusive),
          _this$children$find6 = _slicedToArray(_this$children$find5, 2),
          child = _this$children$find6[0],
          offset = _this$children$find6[1],
          position = [[this, index]];

      return child instanceof _ParentBlot ? position.concat(child.path(offset, inclusive)) : (child != null && position.push([child, offset]), position);
    }
  }, {
    key: "removeChild",
    value: function removeChild(child) {
      this.children.remove(child);
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(name, value) {
      var replacement = typeof name == "string" ? this.scroll.create(name, value) : name;
      return replacement instanceof _ParentBlot && this.moveChildren(replacement), _get(_getPrototypeOf(_ParentBlot.prototype), "replaceWith", this).call(this, replacement);
    }
  }, {
    key: "split",
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (!force) {
        if (index === 0) return this;
        if (index === this.length()) return this.next;
      }

      var after = this.clone();
      return this.parent && this.parent.insertBefore(after, this.next || void 0), this.children.forEachAt(index, this.length(), function (child, offset, _length) {
        var split = child.split(offset, force);
        split != null && after.appendChild(split);
      }), after;
    }
  }, {
    key: "splitAfter",
    value: function splitAfter(child) {
      var after = this.clone();

      for (; child.next != null;) {
        after.appendChild(child.next);
      }

      return this.parent && this.parent.insertBefore(after, this.next || void 0), after;
    }
  }, {
    key: "unwrap",
    value: function unwrap() {
      this.parent && this.moveChildren(this.parent, this.next || void 0), this.remove();
    }
  }, {
    key: "update",
    value: function update(mutations, _context) {
      var _this11 = this;

      var addedNodes = [],
          removedNodes = [];
      mutations.forEach(function (mutation) {
        mutation.target === _this11.domNode && mutation.type === "childList" && (addedNodes.push.apply(addedNodes, _toConsumableArray(mutation.addedNodes)), removedNodes.push.apply(removedNodes, _toConsumableArray(mutation.removedNodes)));
      }), removedNodes.forEach(function (node) {
        if (node.parentNode != null && // @ts-expect-error Fix me later
        node.tagName !== "IFRAME" && document.body.compareDocumentPosition(node) & Node.DOCUMENT_POSITION_CONTAINED_BY) return;

        var blot = _this11.scroll.find(node);

        blot != null && (blot.domNode.parentNode == null || blot.domNode.parentNode === _this11.domNode) && blot.detach();
      }), addedNodes.filter(function (node) {
        return node.parentNode === _this11.domNode && node !== _this11.uiNode;
      }).sort(function (a, b) {
        return a === b ? 0 : a.compareDocumentPosition(b) & Node.DOCUMENT_POSITION_FOLLOWING ? 1 : -1;
      }).forEach(function (node) {
        var refBlot = null;
        node.nextSibling != null && (refBlot = _this11.scroll.find(node.nextSibling));
        var blot = makeAttachedBlot(node, _this11.scroll);
        (blot.next !== refBlot || blot.next == null) && (blot.parent != null && blot.parent.removeChild(_this11), _this11.insertBefore(blot, refBlot || void 0));
      }), this.enforceAllowedChildren();
    }
  }]);

  return _ParentBlot;
}(ShadowBlot);

_ParentBlot.uiClass = "";
var ParentBlot = _ParentBlot;
var ParentBlot$1 = ParentBlot;

function isEqual(obj1, obj2) {
  if (Object.keys(obj1).length !== Object.keys(obj2).length) return !1;

  for (var prop in obj1) {
    if (obj1[prop] !== obj2[prop]) return !1;
  }

  return !0;
}

var _InlineBlot = /*#__PURE__*/function (_ParentBlot$) {
  _inherits(_InlineBlot, _ParentBlot$);

  var _super6 = _createSuper(_InlineBlot);

  function _InlineBlot(scroll, domNode) {
    var _this12;

    _classCallCheck(this, _InlineBlot);

    _this12 = _super6.call(this, scroll, domNode), _this12.attributes = new AttributorStore$1(_this12.domNode);
    return _this12;
  }

  _createClass(_InlineBlot, [{
    key: "format",
    value: function format(name, value) {
      var _this13 = this;

      if (name === this.statics.blotName && !value) this.children.forEach(function (child) {
        child instanceof _InlineBlot || (child = child.wrap(_InlineBlot.blotName, !0)), _this13.attributes.copy(child);
      }), this.unwrap();else {
        var format = this.scroll.query(name, Scope.INLINE);
        if (format == null) return;
        format instanceof Attributor ? this.attributes.attribute(format, value) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value);
      }
    }
  }, {
    key: "formats",
    value: function formats() {
      var formats = this.attributes.values(),
          format = this.statics.formats(this.domNode, this.scroll);
      return format != null && (formats[this.statics.blotName] = format), formats;
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      this.formats()[name] != null || this.scroll.query(name, Scope.ATTRIBUTE) ? this.isolate(index, length).format(name, value) : _get(_getPrototypeOf(_InlineBlot.prototype), "formatAt", this).call(this, index, length, name, value);
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      _get(_getPrototypeOf(_InlineBlot.prototype), "optimize", this).call(this, context);

      var formats = this.formats();
      if (Object.keys(formats).length === 0) return this.unwrap();
      var next = this.next;
      next instanceof _InlineBlot && next.prev === this && isEqual(formats, next.formats()) && (next.moveChildren(this), next.remove());
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(name, value) {
      var replacement = _get(_getPrototypeOf(_InlineBlot.prototype), "replaceWith", this).call(this, name, value);

      return this.attributes.copy(replacement), replacement;
    }
  }, {
    key: "update",
    value: function update(mutations, context) {
      var _this14 = this;

      _get(_getPrototypeOf(_InlineBlot.prototype), "update", this).call(this, mutations, context), mutations.some(function (mutation) {
        return mutation.target === _this14.domNode && mutation.type === "attributes";
      }) && this.attributes.build();
    }
  }, {
    key: "wrap",
    value: function wrap(name, value) {
      var wrapper = _get(_getPrototypeOf(_InlineBlot.prototype), "wrap", this).call(this, name, value);

      return wrapper instanceof _InlineBlot && this.attributes.move(wrapper), wrapper;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return _get(_getPrototypeOf(_InlineBlot), "create", this).call(this, value);
    }
  }, {
    key: "formats",
    value: function formats(domNode, scroll) {
      var match2 = scroll.query(_InlineBlot.blotName);

      if (!(match2 != null && domNode.tagName === match2.tagName)) {
        if (typeof this.tagName == "string") return !0;
        if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
      }
    }
  }]);

  return _InlineBlot;
}(ParentBlot$1);

_InlineBlot.allowedChildren = [_InlineBlot, LeafBlot$1], _InlineBlot.blotName = "inline", _InlineBlot.scope = Scope.INLINE_BLOT, _InlineBlot.tagName = "SPAN";
var InlineBlot = _InlineBlot;

var InlineBlot$1 = InlineBlot,
    _BlockBlot = /*#__PURE__*/function (_ParentBlot$2) {
  _inherits(_BlockBlot, _ParentBlot$2);

  var _super7 = _createSuper(_BlockBlot);

  function _BlockBlot(scroll, domNode) {
    var _this15;

    _classCallCheck(this, _BlockBlot);

    _this15 = _super7.call(this, scroll, domNode), _this15.attributes = new AttributorStore$1(_this15.domNode);
    return _this15;
  }

  _createClass(_BlockBlot, [{
    key: "format",
    value: function format(name, value) {
      var format = this.scroll.query(name, Scope.BLOCK);
      format != null && (format instanceof Attributor ? this.attributes.attribute(format, value) : name === this.statics.blotName && !value ? this.replaceWith(_BlockBlot.blotName) : value && (name !== this.statics.blotName || this.formats()[name] !== value) && this.replaceWith(name, value));
    }
  }, {
    key: "formats",
    value: function formats() {
      var formats = this.attributes.values(),
          format = this.statics.formats(this.domNode, this.scroll);
      return format != null && (formats[this.statics.blotName] = format), formats;
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      this.scroll.query(name, Scope.BLOCK) != null ? this.format(name, value) : _get(_getPrototypeOf(_BlockBlot.prototype), "formatAt", this).call(this, index, length, name, value);
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      if (def == null || this.scroll.query(value, Scope.INLINE) != null) _get(_getPrototypeOf(_BlockBlot.prototype), "insertAt", this).call(this, index, value, def);else {
        var after = this.split(index);

        if (after != null) {
          var blot = this.scroll.create(value, def);
          after.parent.insertBefore(blot, after);
        } else throw new Error("Attempt to insertAt after block boundaries");
      }
    }
  }, {
    key: "replaceWith",
    value: function replaceWith(name, value) {
      var replacement = _get(_getPrototypeOf(_BlockBlot.prototype), "replaceWith", this).call(this, name, value);

      return this.attributes.copy(replacement), replacement;
    }
  }, {
    key: "update",
    value: function update(mutations, context) {
      var _this16 = this;

      _get(_getPrototypeOf(_BlockBlot.prototype), "update", this).call(this, mutations, context), mutations.some(function (mutation) {
        return mutation.target === _this16.domNode && mutation.type === "attributes";
      }) && this.attributes.build();
    }
  }], [{
    key: "create",
    value: function create(value) {
      return _get(_getPrototypeOf(_BlockBlot), "create", this).call(this, value);
    }
  }, {
    key: "formats",
    value: function formats(domNode, scroll) {
      var match2 = scroll.query(_BlockBlot.blotName);

      if (!(match2 != null && domNode.tagName === match2.tagName)) {
        if (typeof this.tagName == "string") return !0;
        if (Array.isArray(this.tagName)) return domNode.tagName.toLowerCase();
      }
    }
  }]);

  return _BlockBlot;
}(ParentBlot$1);

_BlockBlot.blotName = "block", _BlockBlot.scope = Scope.BLOCK_BLOT, _BlockBlot.tagName = "P", _BlockBlot.allowedChildren = [InlineBlot$1, _BlockBlot, LeafBlot$1];
var BlockBlot = _BlockBlot;

var BlockBlot$1 = BlockBlot,
    _ContainerBlot = /*#__PURE__*/function (_ParentBlot$3) {
  _inherits(_ContainerBlot, _ParentBlot$3);

  var _super8 = _createSuper(_ContainerBlot);

  function _ContainerBlot() {
    _classCallCheck(this, _ContainerBlot);

    return _super8.apply(this, arguments);
  }

  _createClass(_ContainerBlot, [{
    key: "checkMerge",
    value: function checkMerge() {
      return this.next !== null && this.next.statics.blotName === this.statics.blotName;
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      _get(_getPrototypeOf(_ContainerBlot.prototype), "deleteAt", this).call(this, index, length), this.enforceAllowedChildren();
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      _get(_getPrototypeOf(_ContainerBlot.prototype), "formatAt", this).call(this, index, length, name, value), this.enforceAllowedChildren();
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      _get(_getPrototypeOf(_ContainerBlot.prototype), "insertAt", this).call(this, index, value, def), this.enforceAllowedChildren();
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      _get(_getPrototypeOf(_ContainerBlot.prototype), "optimize", this).call(this, context), this.children.length > 0 && this.next != null && this.checkMerge() && (this.next.moveChildren(this), this.next.remove());
    }
  }]);

  return _ContainerBlot;
}(ParentBlot$1);

_ContainerBlot.blotName = "container", _ContainerBlot.scope = Scope.BLOCK_BLOT;
var ContainerBlot = _ContainerBlot;
var ContainerBlot$1 = ContainerBlot;

var EmbedBlot = /*#__PURE__*/function (_LeafBlot$) {
  _inherits(EmbedBlot, _LeafBlot$);

  var _super9 = _createSuper(EmbedBlot);

  function EmbedBlot() {
    _classCallCheck(this, EmbedBlot);

    return _super9.apply(this, arguments);
  }

  _createClass(EmbedBlot, [{
    key: "format",
    value: function format(name, value) {
      _get(_getPrototypeOf(EmbedBlot.prototype), "formatAt", this).call(this, 0, this.length(), name, value);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      index === 0 && length === this.length() ? this.format(name, value) : _get(_getPrototypeOf(EmbedBlot.prototype), "formatAt", this).call(this, index, length, name, value);
    }
  }, {
    key: "formats",
    value: function formats() {
      return this.statics.formats(this.domNode, this.scroll);
    }
  }], [{
    key: "formats",
    value: function formats(_domNode, _scroll) {}
  }]);

  return EmbedBlot;
}(LeafBlot$1);

var EmbedBlot$1 = EmbedBlot,
    OBSERVER_CONFIG = {
  attributes: !0,
  characterData: !0,
  characterDataOldValue: !0,
  childList: !0,
  subtree: !0
},
    MAX_OPTIMIZE_ITERATIONS = 100,
    _ScrollBlot = /*#__PURE__*/function (_ParentBlot$4) {
  _inherits(_ScrollBlot, _ParentBlot$4);

  var _super10 = _createSuper(_ScrollBlot);

  function _ScrollBlot(registry, node) {
    var _this17;

    _classCallCheck(this, _ScrollBlot);

    _this17 = _super10.call(this, null, node), _this17.registry = registry, _this17.scroll = _assertThisInitialized(_this17), _this17.build(), _this17.observer = new MutationObserver(function (mutations) {
      _this17.update(mutations);
    }), _this17.observer.observe(_this17.domNode, OBSERVER_CONFIG), _this17.attach();
    return _this17;
  }

  _createClass(_ScrollBlot, [{
    key: "create",
    value: function create(input, value) {
      return this.registry.create(this, input, value);
    }
  }, {
    key: "find",
    value: function find(node) {
      var bubble = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;
      var blot = this.registry.find(node, bubble);
      return blot ? blot.scroll === this ? blot : bubble ? this.find(blot.scroll.domNode.parentNode, !0) : null : null;
    }
  }, {
    key: "query",
    value: function query(_query2) {
      var scope = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : Scope.ANY;
      return this.registry.query(_query2, scope);
    }
  }, {
    key: "register",
    value: function register() {
      var _this$registry;

      return (_this$registry = this.registry).register.apply(_this$registry, arguments);
    }
  }, {
    key: "build",
    value: function build() {
      this.scroll != null && _get(_getPrototypeOf(_ScrollBlot.prototype), "build", this).call(this);
    }
  }, {
    key: "detach",
    value: function detach() {
      _get(_getPrototypeOf(_ScrollBlot.prototype), "detach", this).call(this), this.observer.disconnect();
    }
  }, {
    key: "deleteAt",
    value: function deleteAt(index, length) {
      this.update(), index === 0 && length === this.length() ? this.children.forEach(function (child) {
        child.remove();
      }) : _get(_getPrototypeOf(_ScrollBlot.prototype), "deleteAt", this).call(this, index, length);
    }
  }, {
    key: "formatAt",
    value: function formatAt(index, length, name, value) {
      this.update(), _get(_getPrototypeOf(_ScrollBlot.prototype), "formatAt", this).call(this, index, length, name, value);
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      this.update(), _get(_getPrototypeOf(_ScrollBlot.prototype), "insertAt", this).call(this, index, value, def);
    }
  }, {
    key: "optimize",
    value: function optimize() {
      var _this18 = this;

      var mutations = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      _get(_getPrototypeOf(_ScrollBlot.prototype), "optimize", this).call(this, context);

      var mutationsMap = context.mutationsMap || /* @__PURE__ */new WeakMap();
      var records = Array.from(this.observer.takeRecords());

      for (; records.length > 0;) {
        mutations.push(records.pop());
      }

      var mark = function mark(blot) {
        var markParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !0;
        blot == null || blot === _this18 || blot.domNode.parentNode != null && (mutationsMap.has(blot.domNode) || mutationsMap.set(blot.domNode, []), markParent && mark(blot.parent));
      },
          optimize = function optimize(blot) {
        mutationsMap.has(blot.domNode) && (blot instanceof ParentBlot$1 && blot.children.forEach(optimize), mutationsMap["delete"](blot.domNode), blot.optimize(context));
      };

      var remaining = mutations;

      for (var i = 0; remaining.length > 0; i += 1) {
        if (i >= MAX_OPTIMIZE_ITERATIONS) throw new Error("[Parchment] Maximum optimize iterations reached");

        for (remaining.forEach(function (mutation) {
          var blot = _this18.find(mutation.target, !0);

          blot != null && (blot.domNode === mutation.target && (mutation.type === "childList" ? (mark(_this18.find(mutation.previousSibling, !1)), Array.from(mutation.addedNodes).forEach(function (node) {
            var child = _this18.find(node, !1);

            mark(child, !1), child instanceof ParentBlot$1 && child.children.forEach(function (grandChild) {
              mark(grandChild, !1);
            });
          })) : mutation.type === "attributes" && mark(blot.prev)), mark(blot));
        }), this.children.forEach(optimize), remaining = Array.from(this.observer.takeRecords()), records = remaining.slice(); records.length > 0;) {
          mutations.push(records.pop());
        }
      }
    }
  }, {
    key: "update",
    value: function update(mutations) {
      var _this19 = this;

      var context = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      mutations = mutations || this.observer.takeRecords();
      var mutationsMap = /* @__PURE__ */new WeakMap();
      mutations.map(function (mutation) {
        var blot = _this19.find(mutation.target, !0);

        return blot == null ? null : mutationsMap.has(blot.domNode) ? (mutationsMap.get(blot.domNode).push(mutation), null) : (mutationsMap.set(blot.domNode, [mutation]), blot);
      }).forEach(function (blot) {
        blot != null && blot !== _this19 && mutationsMap.has(blot.domNode) && blot.update(mutationsMap.get(blot.domNode) || [], context);
      }), context.mutationsMap = mutationsMap, mutationsMap.has(this.domNode) && _get(_getPrototypeOf(_ScrollBlot.prototype), "update", this).call(this, mutationsMap.get(this.domNode), context), this.optimize(mutations, context);
    }
  }]);

  return _ScrollBlot;
}(ParentBlot$1);

_ScrollBlot.blotName = "scroll", _ScrollBlot.defaultChild = BlockBlot$1, _ScrollBlot.allowedChildren = [BlockBlot$1, ContainerBlot$1], _ScrollBlot.scope = Scope.BLOCK_BLOT, _ScrollBlot.tagName = "DIV";
var ScrollBlot = _ScrollBlot;

var ScrollBlot$1 = ScrollBlot,
    _TextBlot = /*#__PURE__*/function (_LeafBlot$2) {
  _inherits(_TextBlot, _LeafBlot$2);

  var _super11 = _createSuper(_TextBlot);

  function _TextBlot(scroll, node) {
    var _this20;

    _classCallCheck(this, _TextBlot);

    _this20 = _super11.call(this, scroll, node), _this20.text = _this20.statics.value(_this20.domNode);
    return _this20;
  }

  _createClass(_TextBlot, [{
    key: "deleteAt",
    value: function deleteAt(index, length) {
      this.domNode.data = this.text = this.text.slice(0, index) + this.text.slice(index + length);
    }
  }, {
    key: "index",
    value: function index(node, offset) {
      return this.domNode === node ? offset : -1;
    }
  }, {
    key: "insertAt",
    value: function insertAt(index, value, def) {
      def == null ? (this.text = this.text.slice(0, index) + value + this.text.slice(index), this.domNode.data = this.text) : _get(_getPrototypeOf(_TextBlot.prototype), "insertAt", this).call(this, index, value, def);
    }
  }, {
    key: "length",
    value: function length() {
      return this.text.length;
    }
  }, {
    key: "optimize",
    value: function optimize(context) {
      _get(_getPrototypeOf(_TextBlot.prototype), "optimize", this).call(this, context), this.text = this.statics.value(this.domNode), this.text.length === 0 ? this.remove() : this.next instanceof _TextBlot && this.next.prev === this && (this.insertAt(this.length(), this.next.value()), this.next.remove());
    }
  }, {
    key: "position",
    value: function position(index) {
      var _inclusive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      return [this.domNode, index];
    }
  }, {
    key: "split",
    value: function split(index) {
      var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : !1;

      if (!force) {
        if (index === 0) return this;
        if (index === this.length()) return this.next;
      }

      var after = this.scroll.create(this.domNode.splitText(index));
      return this.parent.insertBefore(after, this.next || void 0), this.text = this.statics.value(this.domNode), after;
    }
  }, {
    key: "update",
    value: function update(mutations, _context) {
      var _this21 = this;

      mutations.some(function (mutation) {
        return mutation.type === "characterData" && mutation.target === _this21.domNode;
      }) && (this.text = this.statics.value(this.domNode));
    }
  }, {
    key: "value",
    value: function value() {
      return this.text;
    }
  }], [{
    key: "create",
    value: function create(value) {
      return document.createTextNode(value);
    }
  }, {
    key: "value",
    value: function value(domNode) {
      return domNode.data;
    }
  }]);

  return _TextBlot;
}(LeafBlot$1);

_TextBlot.blotName = "text", _TextBlot.scope = Scope.INLINE_BLOT;
var TextBlot = _TextBlot;
var TextBlot$1 = TextBlot;
export { Attributor, AttributorStore$1 as AttributorStore, BlockBlot$1 as BlockBlot, ClassAttributor$1 as ClassAttributor, ContainerBlot$1 as ContainerBlot, EmbedBlot$1 as EmbedBlot, InlineBlot$1 as InlineBlot, LeafBlot$1 as LeafBlot, ParentBlot$1 as ParentBlot, Registry, Scope, ScrollBlot$1 as ScrollBlot, StyleAttributor$1 as StyleAttributor, TextBlot$1 as TextBlot };